import { AccountAddressSortOption } from '@rematter/frontend-lib-api-client';

import { ObjectRefRecord } from '~/shared/components/custom-attributes/types';
import { createQueryHook } from '~/shared/providers/api';

export const useCRMAccountAddressesQuery = createQueryHook(
  'crm.accountAddresses',
  (params: {
    searchTerm?: string;
    sorting?: AccountAddressSortOption[];
    limit?: number;
    offset?: number;
  }) => ({
    accountAddresses: {
      __args: {
        filter: params.searchTerm
          ? {
              searchTerm: params.searchTerm,
            }
          : undefined,
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 10,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        id: true,
        name: true,
      },
    },
  }),
  {
    select: (data): ObjectRefRecord[] =>
      data?.accountAddresses.entries.map((address) => ({
        id: address.id,
        name: address.name ?? '',
      })) ?? [],
  },
);
